// DS: B0
import React from 'react';
import { useTranslation } from 'react-i18next';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import Add from '@wix/da-ds/pkg/Icons/24x24/Add';
import { useSubmitMenuItem } from '../../../useSubmitMenuItem';
import { submitButtonMenuItem } from '../../../constants';
var SubmitButton = function (_a) {
    var id = _a.id, className = _a.className, isOpen = _a.isOpen, onClick = _a.onClick, children = _a.children, ariaControls = _a["aria-controls"];
    var t = useTranslation().t;
    var _b = useSubmitMenuItem(submitButtonMenuItem), href = _b.href, biData = _b.biData, submitOnClick = _b.onClick;
    return (React.createElement(BrandedButton, { id: id, size: "medium", variant: "brand-green", icon: Add, className: className, href: href, onClick: submitOnClick, biData: biData, "aria-haspopup": true, "aria-expanded": isOpen, "aria-controls": ariaControls }, t('siteHeader.submit')));
};
SubmitButton.displayName = 'SubmitButton';
export default SubmitButton;
//# sourceMappingURL=SubmitButton.js.map